import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { RootScopeService } from './root-scope.service';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import * as Constants from '../models/Constants';
import _ from 'lodash';
import { AwsSqsService } from './aws-sqs.service';
import { InteractionDTO } from '../models/customer.model';

@Injectable({
  providedIn: 'root'
})
export class OnDemandEmailService {

  onDemandForm: FormGroup = new FormGroup({});
  emailPattern  = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Stricter email regex

  constructor(public rootScope: RootScopeService,
    public fb: FormBuilder,
    public apiService: ApiService) { }

  /** Below method create On-DemandEmailForm */
    createOnDemandEmailForm() {
    this.onDemandForm = this.fb.group({
      template: ['', Validators.required],
      email: [[], [Validators.required,this.multiEmailValidator()]],
      title: [{ value: '', disabled: true }],
      description: [{ value: '', disabled: true }],
    });
  }

  /**Below method retain the data of On-Demand Email Form when user switch the Tab between Customer Account or Dashboard */
  retainOnDemandEmailDataForTabChange() {
    const selectedTemplateList = this.rootScope?.activeCustTab?.onDemandEmailData?.selectedTemplateList;
    const emailId = this.rootScope?.activeCustTab?.onDemandEmailData?.emailId;

    // Check if selectedTemplate is not null, undefined, and has keys
    if (selectedTemplateList && Object?.keys(selectedTemplateList)?.length > 0) {
      this.onDemandForm.get('template')?.setValue(selectedTemplateList?.name || '');
      this.onDemandForm.get('email')?.setValue(emailId || '');
      this.onDemandForm.get('title')?.setValue(selectedTemplateList?.subject || '');
      this.onDemandForm.get('description')?.setValue(selectedTemplateList?.body || '');
    }

  }

/** This method retrieves the On-Demand Email configuration from the Tab DTO cache. 
 * If the data is not available, it makes an API call to the backend. */
getOnDemandEmailConfig() {
    const emailTemplateList = this.rootScope.activeCustTab.onDemandEmailData?.emailTemplateList;

    if (emailTemplateList?.length > 0) {

    } else {
      this.getOnDemandEmailConfigFromServer();
    }
  }

  /**Below method fetch the data from backend for On-Demand Email Configuration */
    
  getOnDemandEmailConfigFromServer() {
    const clientId = this.rootScope.activeCustTab.clientId;
    this.rootScope.activeCustTab.onDemandEmailData.onDemandEmailApiFailure = false;

    this.apiService.getOnDemandEmailConfigData(clientId).subscribe({
      next: (data: any) => {
        const emailTemplateList = data?.data?.emailTemplateList;
        const emailId = data?.data?.emailId;

        if (emailTemplateList?.length > 0) {
          this.rootScope.activeCustTab.onDemandEmailData.emailId = emailId;
          this.rootScope.activeCustTab.onDemandEmailData.emailTemplateList = emailTemplateList;

        } else {
          this.rootScope.activeCustTab.onDemandEmailData.onDemandEmailConfigMiss = true;
        }

      },
      error: (err) => {
        this.rootScope.activeCustTab.onDemandEmailData.onDemandEmailApiFailure = true;
      }
    })
  }

 /**
  * saving  on Demand EMail IH .It will be different entry along with main IH created
  * at the time of wrap up.
  * @param begin
  * @returns 
  */
  createOnDemandEmailIH(begin){

    let currentActiveTab = this.rootScope.activeCustTab;
    let interactionEventDTO = new InteractionDTO();
    interactionEventDTO.externalRefId = this.rootScope.activeCustTab.conversationId;
    interactionEventDTO.created =  new Date(currentActiveTab?.startTime)?.toISOString() || new Date().toISOString(), 
    interactionEventDTO.begin = begin,
    interactionEventDTO.end = new Date().toISOString(),
    interactionEventDTO.channel =  Constants.IH_Email;
    interactionEventDTO.initiated = Constants.IH_INTERNAL_CALL;
    interactionEventDTO.details = this.onDemandForm.value.template;
    interactionEventDTO.description = this.onDemandForm?.get('title')?.value,
    interactionEventDTO.system = Constants.CP_SYSTEM_IH;
    interactionEventDTO.clientId = this.rootScope.checkClientSystemMappingAndReplace(currentActiveTab?.clientId);// tabdt?.clientId;
      if (interactionEventDTO.clientId == null) {
        interactionEventDTO.clientId = currentActiveTab?.clientId;
      }
    
    interactionEventDTO.contact = {
      id: currentActiveTab?.id,
      name: currentActiveTab?.title,
      type: currentActiveTab?.customerType, // ? this.rootScope.customerTypeData.find(xx => xx?.fieldValue == parentDetails.customerType)?.fieldValueDescription : "NA",
      phoneNumber:
      currentActiveTab?.channel == Constants.conversion.chat
          ? 'N/A'
          : currentActiveTab?.tabData?.phoneNumber,
      emailAddress:  this.onDemandForm?.get('email')?.value,
      ipAddress: 'N/A',
      role: currentActiveTab?.defaultRole,
    };

      // delegate
      interactionEventDTO.delegate = {
        name: this.rootScope.firstName + ' ' + this.rootScope.lastName,
        delegateId: this.rootScope?.lanId ? this.rootScope?.lanId : sessionStorage.getItem('lanId'),
        phoneNumber: 'N/A',
        emailAddress: this.rootScope.emailId,
      };
    interactionEventDTO.buckets = [];
    
    return interactionEventDTO ;

   

  
  }

  // Validator to check for invalid emails
  multiEmailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const emails = control.value; // Get the value of the control
      if (!emails || emails.length === 0) return null; // If no value, validation is fine (no error)
  
      // Split by commas or semicolons and trim whitespace
      const emailArray = emails.split(/[;,]+/).map(email => email.trim());
  
      // Define a regex pattern for validating emails
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
      // Find invalid emails
      const invalidEmails = emailArray.filter(email => !emailPattern.test(email));
  
      // If there are invalid emails, return an error object, otherwise return null (no error)
      return invalidEmails.length > 0 ? { invalidEmails: invalidEmails } : null;
    };
  }
  

}
